const DECIMALS = 2;

export const formatRoiNumber = (
  value: number,
  locale: string,
  decimals: number = DECIMALS,
): string =>
  new Intl.NumberFormat(locale, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value);

export const formatRoiCurrency = (
  value: number,
  locale: string,
  currency?: string,
): string =>
  new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currency || "USD",
    minimumFractionDigits: DECIMALS,
    maximumFractionDigits: DECIMALS,
  }).format(value);

export const formatRoiPercentage = (value: number, locale: string): string =>
  `${formatRoiNumber(Math.abs(value), locale)} %`;
